import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

/**
 * Button component
 * @class Button
 * @extends {Component}
 */

class Button extends React.Component {
  static propTypes = {
    /** Title show in the Button */
    id: PropTypes.string.isRequired,
    /** Boolean to toggle disable */
    disabled: PropTypes.bool,
    /** An onclick funciton to be passed */
    onClick: PropTypes.func.isRequired,
    /** A text to appear in the button */
    submitText: PropTypes.string.isRequired,
  };

  static defaultProps = { disabled: false, };

  render() {
    const {
      id, disabled, onClick, submitText,
    } = this.props;

    return (
      <button
        id={id}
        className='Custom-Button'
        type='submit'
        disabled={disabled}
        onClick={onClick}
      >
        {submitText}
      </button>
    );
  }
}

export default Button;
